export function checkoutNotificationPermission() {
        const permission = Notification.permission;
        if (permission === 'granted') {
            return 1
        } else if (permission === 'denied') {
            return 0
        } else {
          return 2
        }
}
export async function requestNotificationPermission () {
        const registration = await navigator.serviceWorker.ready;
        const permissionResult = await Notification.requestPermission();

        const urlBase64ToUint8Array = (base64String) => {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/-/g, '+')
                .replace(/_/g, '/');

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            console.log(outputArray);
            return outputArray;
        }
        if(permissionResult !== 'granted') {
            if (permissionResult === 'denied') {
                return {
                    status: 0,
                    data:{}
                }
            }    
        }         
        
        const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array("BJSgOcMVn3AC-N51Fv0GJrew97S_PnyqhX0t6ppC0sfx1yCb7gR-NkcfgBsARTrWMG6VLF-rfBzKnoUsTNUs_zw")
        };
        
        const pushSubscription = await registration.pushManager.subscribe(subscribeOptions);                

        console.log('Received PushSubscription:', JSON.stringify(pushSubscription));
        let data = JSON.parse(JSON.stringify(pushSubscription))
        return {
            status: 1,
            data
        }
}
